import { render, staticRenderFns } from "./CollapseTitleSlot.vue?vue&type=template&id=7355f520&scoped=true&"
import script from "./CollapseTitleSlot.vue?vue&type=script&lang=js&"
export * from "./CollapseTitleSlot.vue?vue&type=script&lang=js&"
import style0 from "./CollapseTitleSlot.vue?vue&type=style&index=0&id=7355f520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7355f520",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7355f520')) {
      api.createRecord('7355f520', component.options)
    } else {
      api.reload('7355f520', component.options)
    }
    module.hot.accept("./CollapseTitleSlot.vue?vue&type=template&id=7355f520&scoped=true&", function () {
      api.rerender('7355f520', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/workPermits/CollapseTitleSlot.vue"
export default component.exports